// extracted by mini-css-extract-plugin
export default {"userInfo":"jgcY1S7NvfRwWMRQc_2s","userInfoTextContainer":"XSi_9qMrHmOPh8V1VdKE","userInfoTitle":"Qd2lUAIDEWqMkIpz_t2d","userInfoSubtitle":"knKePu3OBy63yTNpFGJJ"};